<template>
<div>
<div class="col-md-4 mx-auto p-0">

<div class="text-center pb-3 pt-2">
  <h1 class="text-white landing-heading">Don't lose your assets. We'll help you<br><span class="yellow">get out of debt</span></h1>
</div>
<div class="card" style="background-color:#d30051 !important;">
<div class="card-body">

  <div class="text-center">
    <div class="text-white pb-4">Please fill in the form and a consultant will call you</div>
  </div>

    <div class="alert alert-secondary text-center" role="alert" v-if="error_message">
    <span v-html="error_message"></span>
    </div>
      
    <div class="form-group mb-3">
        <input type="text" placeholder="Your name" class="form-control3" v-model="name">
    </div>

    <div class="form-group mb-3">
        <input type="text" placeholder="Mobile phone number" maxlength="10" class="form-control3" v-model="phone">

    </div>

    <div class="form-group mb-3">
        <input type="text" placeholder="Email address" class="form-control3" v-model="email">
    </div>

    <div class="d-grid mx-auto">
        <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin fa-1x text-white"></i></div>
        <button v-else type="submit" :class="'btn btn-warning btn-block'" @click="submitForm">Let's do this</button>
    </div>

</div>
</div>
</div>
<landing-footer v-if="!submitted"></landing-footer>
</div>
</template>

<script>

export default {
  data() {
    return {
      page: 'debt',
      name: null,
      phone: null,
      email: null,
      amount: null,
      error_message: null,
      loading: false,
      submitted: false,
    };
  },

  methods: {

      submitForm() {

          this.error_message = null;

          if (!this.name || this.name == '') { this.sweetfire('Please enter your name')}
          else if (!this.phone || this.phone == '') { this.sweetfire('Please enter your phone number')}
          else if (!this.email || this.email == '') { this.sweetfire('Please enter your email address')}

          else {

          this.loading = true;

          axios
          .post('/leads/submit', {
            page: this.page,
            name: this.name, 
            phone: this.phone, 
            email: this.email,
            amount: this.amount,
            })
          .then((response) => {
            
            if (response.data.success) {
                window.location.href = response.data.url;
            }

            else {
              this.error_message = response.data.message;
              this.loading = false;
            }

          });

          }
      
      },

  },
};
</script> 